export enum CsvJobStateEnum {
  PENDING = "pending",
  QUEUED = "queued",
}

export enum CsvJobNameEnum {
  TEAM_USERS = "team_users_csv_job",
}
